export default __webpack_public_path__ + "static/media/about_me.fee4f53e.jpg";